import type { ReactNode } from 'react';
import { Link } from 'react-router';

import { cn } from '@/lib/cn';

import { Label } from './Label';

type SectionHeadProps = {
  title: ReactNode;
  id?: string;
  eyebrow?: string;
  /** Lien « Tout le blog → » aligné à droite, ou tout autre élément. */
  aside?: ReactNode;
  /** Sur fond encre, l'eyebrow passe en blanc atténué. */
  onEncre?: boolean;
  className?: string;
};

/** Eyebrow, titre de section et action à droite (maquette, `.head`). */
export function SectionHead({ title, id, eyebrow, aside, onEncre, className }: SectionHeadProps) {
  return (
    <div className={cn('mb-10 flex flex-wrap items-end justify-between gap-6', className)}>
      <div>
        {eyebrow && <Label tone={onEncre ? 'clair' : 'mute'}>{eyebrow}</Label>}
        <h2 id={id} className={cn('text-h2', eyebrow && 'mt-4')}>
          {title}
        </h2>
      </div>
      {aside}
    </div>
  );
}

/** Lien fléché « Tout le blog → ». */
export function ArrowLink({ to, children }: { to: string; children: ReactNode }) {
  return (
    <Link to={to} className="font-medium no-underline hover:text-encre-soft">
      {children} →
    </Link>
  );
}
